// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Buttons{--main-color:#020202;--main-bgcolor:#ffe256;--main-border:#ffe256;font-family:PingFang SC;font-weight:400}.Buttons button{width:100%;border:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
